var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scroller",attrs:{"id":"home_wrapper"}},[_c('div',{staticClass:"position-relative bg-yellow",attrs:{"id":"home"}},[_c('HeroNeighbourhood'),_vm._v(" "),_c('Quartier'),_vm._v(" "),_c('AppFooter'),_vm._v(" "),_c('div',{attrs:{"id":"play"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }